import { R3EventEmitter } from "../../../r3utils/src/events/emitter";

type networkBusDialogs = "disconnected";
type networkBusParams = {
  motivo: string;
  conteudo: string;
}

export default defineNuxtPlugin(() => {

  const eventEmitter = new R3EventEmitter<networkBusDialogs, networkBusParams>(
    ["disconnected"]
  )



  return {
    provide: {
      networkBus: eventEmitter
    }
  }
})